import React, { useEffect, useState } from 'react';
import { usePushNotifications } from '../../hooks/usePushNotifications';
import './PushNotificationPrompt.css';

interface PushNotificationPromptProps {
  onSubscribe?: () => void;
  onDismiss?: () => void;
}

export const PushNotificationPrompt: React.FC<PushNotificationPromptProps> = ({
  onSubscribe,
  onDismiss,
}) => {
  const { permission, isSubscribed, isLoading, subscribe } = usePushNotifications();
  const [showPrompt, setShowPrompt] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Проверяем, был ли промпт уже показан
    const promptDismissed = localStorage.getItem('pushNotificationPromptDismissed');
    if (promptDismissed === 'true') {
      setDismissed(true);
      return;
    }

    // Показываем промпт если:
    // 1. Разрешение еще не запрошено (default)
    // 2. Пользователь еще не подписан
    // 3. Промпт не был отклонен ранее
    if (permission === 'default' && !isSubscribed && !dismissed) {
      setShowPrompt(true);
    } else {
      setShowPrompt(false);
    }
  }, [permission, isSubscribed, dismissed]);

  const handleSubscribe = async () => {
    try {
      await subscribe();
      setShowPrompt(false);
      localStorage.setItem('pushNotificationPromptDismissed', 'true');
      onSubscribe?.();
    } catch (error) {
      console.error('Error subscribing to push notifications:', error);
    }
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    setDismissed(true);
    localStorage.setItem('pushNotificationPromptDismissed', 'true');
    onDismiss?.();
  };

  // Не показываем промпт если:
  // - Загрузка еще идет
  // - Промпт был отклонен
  // - Разрешение уже запрошено или отказано
  // - Пользователь уже подписан
  if (isLoading || !showPrompt || dismissed || permission !== 'default' || isSubscribed) {
    return null;
  }

  return (
    <div className="push-notification-prompt">
      <div className="push-notification-content">
        <div className="push-notification-icon">
          <i className="ri-notification-3-line"></i>
        </div>
        <div className="push-notification-text">
          <h3>Включить уведомления?</h3>
          <p>Получайте push-уведомления о важных событиях даже когда сайт закрыт</p>
        </div>
        <div className="push-notification-actions">
          <button
            className="push-notification-btn push-notification-btn-primary"
            onClick={handleSubscribe}
            disabled={isLoading}
          >
            Включить
          </button>
          <button
            className="push-notification-btn push-notification-btn-secondary"
            onClick={handleDismiss}
            disabled={isLoading}
          >
            Позже
          </button>
        </div>
      </div>
    </div>
  );
};

export default PushNotificationPrompt;

